module.exports = __webpack_public_path__ + "static/media/payroll.83ea98c0.png";